import { useTheme } from "@mui/material";
import Typography from "../typography";

interface FieldErrorProps {
  /** Message to show. Nothing renders when empty. */
  error?: string | null;
}

/**
 * Validation message rendered beneath a form field. Shared by every input
 * primitive so errors look the same everywhere in the app.
 */
const FieldError: React.FC<FieldErrorProps> = ({ error }) => {
  const theme = useTheme();

  if (!error) {
    return null;
  }

  return (
    <Typography
      color="error"
      variant="caption"
      style={{
        fontWeight: theme.typography.fontWeightLight,
        paddingLeft: theme.spacing(1),
        display: "flex",
        marginTop: "-1px",
      }}
    >
      * {error}
    </Typography>
  );
};

export default FieldError;
